// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file inventory/v1/control_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import { ControlInventoryService } from "./control_service_pb";

/**
 * @generated from rpc inventory.v1.ControlInventoryService.ListControlSettings
 */
export const listControlSettings = ControlInventoryService.method.listControlSettings;

/**
 * @generated from rpc inventory.v1.ControlInventoryService.UpdateControlSettings
 */
export const updateControlSettings = ControlInventoryService.method.updateControlSettings;

/**
 * @generated from rpc inventory.v1.ControlInventoryService.GetControlStatusCommentSetting
 */
export const getControlStatusCommentSetting = ControlInventoryService.method.getControlStatusCommentSetting;

/**
 * @generated from rpc inventory.v1.ControlInventoryService.SetControlStatusCommentSetting
 */
export const setControlStatusCommentSetting = ControlInventoryService.method.setControlStatusCommentSetting;

/**
 * @generated from rpc inventory.v1.ControlInventoryService.CreateOrUpdateOrgControlDefinition
 */
export const createOrUpdateOrgControlDefinition = ControlInventoryService.method.createOrUpdateOrgControlDefinition;

/**
 * @generated from rpc inventory.v1.ControlInventoryService.CreateControl
 */
export const createControl = ControlInventoryService.method.createControl;

/**
 * @generated from rpc inventory.v1.ControlInventoryService.DeleteControl
 */
export const deleteControl = ControlInventoryService.method.deleteControl;

/**
 * @generated from rpc inventory.v1.ControlInventoryService.ListControls
 */
export const listControls = ControlInventoryService.method.listControls;

/**
 * @generated from rpc inventory.v1.ControlInventoryService.GetControl
 */
export const getControl = ControlInventoryService.method.getControl;

/**
 * @generated from rpc inventory.v1.ControlInventoryService.UpdateControl
 */
export const updateControl = ControlInventoryService.method.updateControl;

/**
 * @generated from rpc inventory.v1.ControlInventoryService.GetControlTimeline
 */
export const getControlTimeline = ControlInventoryService.method.getControlTimeline;

/**
 * @generated from rpc inventory.v1.ControlInventoryService.ListControlCategories
 */
export const listControlCategories = ControlInventoryService.method.listControlCategories;

/**
 * Records that the current user opened the control Activity tab. A later comment makes the indicator stand out again.
 *
 * @generated from rpc inventory.v1.ControlInventoryService.MarkControlCommentsViewed
 */
export const markControlCommentsViewed = ControlInventoryService.method.markControlCommentsViewed;
